<template>
<div class="chapter">
<div class="inner_page">
<p class="fmc"> </p>
<p class="fmc"> </p>
<p class="fmc"><a id="page_v"></a> </p>
<p class="fmc">‘<em>The eagle of the Roman army goes at the head of every legion – the king of birds, most powerful of them all. . .</em>’</p>
<p class="fmc1">Josephus, <em>Bellum Judiacum</em>, on the First Romano-Jewish War</p>
<p class="fmc">•</p>
<p class="fmc">‘<em>Laureolus gave up his naked flesh to a Caledonian bear . . .</em>’</p>
<p class="fmc1">Martial, <em>Liber Spectaculorum</em>, on the inaugural games of the Colosseum</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?034a2e0d